<div style="font-size: 18px; padding-left: 16px;">LOCAL DE ATENDIMENTO</div> 
<div *ngIf="loading" fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner [diameter]="30"></mat-spinner>
</div>
<mat-list *ngIf="!loading">
    <div fxLayout="column" fxLayoutAlign="start start">
        <mat-list-item *ngFor="let est of estabelecimentos" [ngStyle]="{'background-color': ((est.IdEstabelecimento == IdEstabelecimento)?'#cfcfcf':'')}">
            <button class="establishment-button" mat-button (click)="sel(est)">
                {{est.NomeEstabelecimento}}
            </button>
        </mat-list-item>
    </div>
</mat-list>